var _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgWeight(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M11.469 3.905l-1.091-1.093.473-.474a.5.5 0 10-.707-.708l-.473.474L8.58 1.011a1.848 1.848 0 00-2.552 0 1.807 1.807 0 000 2.557l1.09 1.093-2.946 2.952L3.081 6.52a1.848 1.848 0 00-2.552 0 1.808 1.808 0 000 2.557l1.09 1.093-.473.474a.501.501 0 10.707.708l.474-.474 1.09 1.092A1.804 1.804 0 006.362 10a1.807 1.807 0 00-.391-.586L4.879 8.32l2.95-2.952 1.09 1.093a1.804 1.804 0 002.944-1.97 1.806 1.806 0 00-.392-.587h-.002zm-5.97 6.787a.802.802 0 01-.236.57.823.823 0 01-1.138 0l-2.89-2.894a.807.807 0 01.57-1.376c.213 0 .418.085.57.236l2.888 2.894a.802.802 0 01.236.57zm5.263-4.938a.823.823 0 01-1.139 0L6.736 2.86a.806.806 0 011.138-1.14l2.889 2.894a.806.806 0 010 1.14z",
    fill: "#fff"
  })));
}
export default SvgWeight;